import React,{useState} from 'react'
import { AiOutlineMenu } from "react-icons/ai";
import {Link} from "react-router-dom";
import "../layout/Nav.css";
const NavBar = () => {
    const [toggleMenu,setToggleMenu] = useState(false)
    return (
        <>
            <header className="l-header">
                <nav className="nav bd-grid">
                    <div>
                        <Link to="/" className="nav__logo">CS</Link>
                    </div>
                    <div className={toggleMenu?"nav__menuOn":"nav__menuOff"} id="nav-menu">
                        <ul className="nav__list">
                            <li className="nav__item"> <Link to="/" className="buttonComanderLinke nav__link">ACCUEIL</Link></li>
                            <li className="nav__item"><Link to="/Woman" className="buttonComanderLinke nav__link">ESPADRILLE</Link></li>
                            <li className="nav__item"><Link to="/Sabot" className="buttonComanderLinke nav__link">SABOT</Link></li>
                            <li className="nav__item"><Link to="/Lunettes" className=" buttonComanderLinke nav__link">LUNETTES</Link></li>
                            <li className="nav__item"><a href="#footer" className=" buttonComanderLinke nav__link">CONTACTEZ-NOUS</a></li>
                        </ul>
                    </div>
                    <div className="toggle">
                    <AiOutlineMenu onClick={()=>setToggleMenu(!toggleMenu)} className="nav__toggle" id="nav-toggle"/>
                    </div>

                </nav>
                
            </header>
        </>
    )
}

export default NavBar
